<template>
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :cancelText="$t('antd.table.close')"
      wrapClassName="ant-modal-cust-warp"
      style="top:5%;height: 85%;overflow-y: hidden">
  
      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form"  v-bind="layout"  :model="model" :rules="validatorRules">
          <a-form-model-item :label="$t('system.user.roleNameFormItem')" required prop="roleName">
            <a-input v-model="model.roleName" :placeholder="$t('system.user.placeholderRoleNameFormItem')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('system.character.roleGroupingFormItem')" required prop="roleGroup">
            <a-select v-model="model.roleGroup" :disabled="roleGroupDisabled"  :placeholder="$t('system.character.placeholderRoleGroupingFormItem')">
              <a-select-option v-for="(item, index) in selectGrop" v-bind:key="index" :value="item.roleGroup">
                 {{ item.description  }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('system.character.descriptionFormItem')"  prop="description">
            <a-input v-model="model.description" :placeholder="$t('system.character.placeholderDescriptionFormItem')"/>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
  </template>
  
  <script>
    import { roleCreat, roleUpdate, roleExternal } from '@/api/app'
    export default {
      name: "CharacterCreate",
      data () {
        return {
          selectGrop:[],
          title:this.$t('antd.table.batch'),
          visible: false,
          roleGroupDisabled:false,
          model: {},
          layout: {
            labelCol: { span: 3 },
            wrapperCol: { span: 14 },
          },
          confirmLoading: false,
          validatorRules:{
            roleName: [
              { required: true, message: this.$t('system.user.placeholderRoleNameFormItem') },
            ],
            roleGroup: [
              { required: true, message: this.$t('system.character.placeholderRoleGroupingFormItem')},
            ]
          },
        }
      },
      async created () {
        //备份model原始值
        this.modelDefault = JSON.parse(JSON.stringify(this.model));
        await this.getSelectionGrap()
      },
      methods: {
        async getSelectionGrap(){
         let res = await roleExternal()
         if(res.code == '200'){
            this.selectGrop = res.data;
          }else{
            this.$message.warning(res.msg);
          }
        },
        add () {
          this.edit({...this.modelDefault });
        },
        edit (record) {
          this.model = Object.assign({}, record);
          this.visible = true;
          //编辑页面禁止修改角色分组
          if(this.model.id){
            this.roleGroupDisabled = true;
          }else{
            this.roleGroupDisabled = false;
          }
        },
        close () {
          this.$refs.form.clearValidate();
          this.$emit('close');
          this.visible = false;
        },
        handleOk () {
          const that = this;
          // 触发表单验证
          this.$refs.form.validate(valid => {
            if (valid) {
              that.confirmLoading = true;
              let obj;
              if(!this.model.id){
                obj=roleCreat(this.model);
              }else{
                obj=roleUpdate(this.model);
              }
              obj.then((res)=>{
                if(res.code == '200'){
                  that.$message.success(res.msg);
                  that.$emit('ok');
                }else{
                  that.$message.warning(res.msg);
                }
              }).finally(() => {
                that.confirmLoading = false;
                that.close();
              })
            }else{
              return false;
            }
          })
        },
        handleCancel () {
          this.close()
        },
        validateRoleCode(value, callback){
          if(/[\u4E00-\u9FA5]/g.test(value)){
            callback("角色编码不可输入汉字!");
          }else{
            // let params = {
            //   tableName: "sys_role",
            //   fieldName: "role_code",
            //   fieldVal: value,
            //   dataId: this.model.id,
            // };
            // duplicateCheck(params).then((res)=>{
            //   if(res.success){
            //     callback();
            //   }else{
            //     callback(res.message);
            //   }
            // });
          }
        }
      }
    }
  </script>
  
  <style scoped>
  
  </style>